import { useState } from 'react'
import { toast } from 'sonner'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import CandidateForm from './CandidateForm'

const AddCandidateButton = () => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button size='sm' onClick={() => setOpen(true)}>
        Add candidate
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className='max-w-md'>
          <DialogHeader>
            <DialogTitle>Add candidate</DialogTitle>
          </DialogHeader>
          {open && (
            <CandidateForm
              manual
              inModal
              onCancel={() => setOpen(false)}
              onAdded={() => {
                toast.success('Candidate added')
                setOpen(false)
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  )
}

export default AddCandidateButton
